import React from "react";
import styled from "styled-components";

export default function HorizontalScrollGuide({className}) {
  return (
      <Guide className={className}>
        <kbd aria-hidden="true">⇧</kbd>
        <span>Shift + 스크롤로 좌우 이동</span>
      </Guide>
  );
}

const Guide = styled.div`
  display: flex;
  width: 100%;
  box-sizing: border-box;
  min-height: 28px;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  margin: 10px 0 8px;
  color: var(--color-text-muted);
  font-size: var(--font-size-11);
  text-align: right;

  kbd {
    display: inline-flex;
    width: 18px;
    height: 18px;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--color-border-strong);
    border-radius: 4px;
    background: #f8fafc;
    color: #66727f;
    font-family: inherit;
    font-size: var(--font-size-12);
    box-shadow: 0 1px 1px rgba(31, 41, 55, .05);
  }
`;
